module.exports = __webpack_public_path__ + "static/media/环境减灾一号.8b741f5a.png";